/* @jsx h */
import { defineComponent, ref, h } from "vue";
import { LemmonModal } from "@lemmonhq/uikit";
import { NumPad } from "@lemmonhq/uikit";
import { calculateCheckoutSubTotal } from "@lemmonhq/orders";
import { useCheckout } from "../../providers";

interface TipModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (amount: number | undefined) => void;
}

export const TipModal = defineComponent({
  name: "TipModal",
  props: ["isOpen", "onClose", "onConfirm"],
  setup(props) {
    const checkout = useCheckout();
    const amount = ref("");
    const tipOptions = [5, 10, 15, 20];

    const subtotal = checkout.checkout.value
      ? calculateCheckoutSubTotal(checkout.checkout.value)
      : 0;

    const handleAmountChange = (value: string) => {
      amount.value = value;
    };

    const handlePercentageTip = (percentage: number) => {
      const tipAmount = (subtotal * percentage) / 100;
      props.onConfirm(tipAmount);
      amount.value = "";
      props.onClose();
    };

    const handleSubmit = () => {
      const tipAmount = parseFloat(amount.value);
      if (!isNaN(tipAmount) && tipAmount > 0) {
        props.onConfirm(tipAmount);
      } else {
        props.onConfirm(undefined);
      }
      amount.value = "";
      props.onClose();
    };

    return () =>
      !props.isOpen ? null : (
        <LemmonModal
          title={undefined}
          onClose={props.onClose}
          renderButtons={() => (
            <div class="p-2 border-t ">
              <div class="flex justify-between gap-2">
                <button
                  onClick={props.onClose}
                  class="btn btn-neutral"
                  type="button"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  class="btn btn-primary"
                  type="submit"
                >
                  Add Tip
                </button>
              </div>
            </div>
          )}
        >
          <div class="py-6 px-8">
            <div class="grid grid-cols-4 gap-2 mb-8">
              {tipOptions.map((percentage) => (
                <button
                  key={percentage}
                  class="btn btn btn-secondary border-accent text-accent hover:btn-primary transition-all duration-200"
                  onClick={() => handlePercentageTip(percentage)}
                >
                  {percentage}%
                </button>
              ))}
            </div>

            <div class="relative flex items-center justify-center mb-4">
              <div class="flex-grow border-t border-base-300"></div>
              <div class="px-4 bg-base-100 text-sm font-medium text-base-content/70 rounded-full border border-base-300 shadow-sm">
                or
              </div>
              <div class="flex-grow border-t border-base-300"></div>
            </div>

            <div class="mx-auto" style="max-width: 400px;">
              <NumPad value={amount.value} onChange={handleAmountChange} />
            </div>
          </div>
        </LemmonModal>
      );
  },
});
